var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "materialReturnApplyDrawer" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          staticClass: "con__style",
          attrs: { model: _vm.form, "label-width": "110px", size: "small" },
        },
        [
          _c("div", { staticClass: "section-title" }, [_vm._v("基本信息")]),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { flex: "1", "min-width": "300px" },
                  attrs: {
                    label: "退还人",
                    prop: "refund_user_id",
                    rules: [
                      {
                        required: true,
                        message: "请选择退还人",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "input__width",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择",
                      },
                      on: { change: _vm.changeRefundUser },
                      model: {
                        value: _vm.form.refund_user_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "refund_user_id", $$v)
                        },
                        expression: "form.refund_user_id",
                      },
                    },
                    _vm._l(_vm.sellUserList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: {
                    flex: "1",
                    "min-width": "300px",
                    "margin-left": "20px",
                  },
                  attrs: {
                    label: "退还时间",
                    prop: "date",
                    rules: [
                      {
                        required: true,
                        message: "请选择退还时间",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c("el-date-picker", {
                    staticClass: "input__style",
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd",
                      placeholder: "选择日期",
                    },
                    model: {
                      value: _vm.form.date,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "date", $$v)
                      },
                      expression: "form.date",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { flex: "1", "min-width": "300px" },
                  attrs: { label: "退还备注", prop: "remark" },
                },
                [
                  _c("el-input", {
                    staticClass: "input__width",
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 4, maxRows: 100 },
                      maxlength: 500,
                      "show-word-limit": "",
                      placeholder: "请输入退还备注",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider", { staticStyle: { margin: "20px 0" } }),
          _c(
            "div",
            { staticClass: "section-title" },
            [
              _c("span", [_vm._v("退还物料明细")]),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: {
                    type: "primary",
                    size: "mini",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.handleAddMaterial },
                },
                [_vm._v("添加物料")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", margin: "10px 0 50px 0" },
              attrs: {
                border: "",
                "header-cell-style": {
                  background: "#F1F1F1",
                  color: "#333333",
                },
                data: _vm.form.material_items,
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "物料领用单", prop: "code", align: "left" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料编码",
                  prop: "material_id",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "物料名称", prop: "name", align: "left" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料类型",
                  prop: "material_type_des",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "工艺材质",
                  prop: "craft_type_des",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "规格", prop: "attribute_str", align: "left" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "印刷类型",
                  prop: "print_type_des",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "领取仓库",
                  prop: "branch_office_name",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "领取数量",
                  prop: "receive_num",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "已退还数量",
                  prop: "total_refund_num",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "本次退还数量",
                  width: "130px",
                  prop: "receive_num",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              prop: "material_items." + scope.$index + ".num",
                              rules: [
                                {
                                  required: true,
                                  message: "请输入退还数量",
                                  trigger: "change",
                                },
                                {
                                  pattern: /^[1-9]\d*$/,
                                  message: "请输入正整数",
                                  trigger: "change",
                                },
                              ],
                              "label-width": "0",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入", size: "mini" },
                              model: {
                                value: scope.row.num,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "num", $$v)
                                },
                                expression: "scope.row.num",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.submitLoading,
              },
              on: { click: _vm.submitForm },
            },
            [_vm._v("提交")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawerSelect,
            size: "75%",
            title: "添加物料",
            "append-to-body": true,
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerSelect = $event
            },
          },
        },
        [
          _c("materialReturnSelectDrawer", {
            attrs: { "user-id": _vm.form.refund_user_id },
            on: {
              selected: _vm.handleMaterialSelected,
              close: function ($event) {
                _vm.drawerSelect = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }